const locale = require('./taskReassign.i18n.json');

/*@ngInject*/
const ReassignModalController = function ($rootScope, $scope, $filter, options, localization, coreMediator, coreConstant, submissionConstant) {

    $scope.taskReassignI18n = locale;

    localization.getTranslations().then(function (result) {
        this.translations = result;
        $scope.saveButton = _.get(this.translations, 'homePage.widgets.taskGrid.reassignButton');
        $scope.cancelButton = _.get(this.translations, 'homePage.widgets.taskGrid.cancel');
    }.bind(this));

    $scope.title = options.title;
    $scope.summary = options.summary;
    $scope.filteredItemsList = [];

    $scope.reassignViewModel = {
        selectedAssignee: null
    };

    $scope.onConfirm = function () {
        $scope.$close($scope.reassignViewModel.selectedAssignee);
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    coreMediator.loadUsersList().then(function(users) {
         $scope.peopleList = users;
        });

    $scope.filterItems = function (searchText) {
        let filteredItemsList = [];
        const maxItems = 150;

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter($scope.peopleList, function (item) {
                return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
            });
            //if after searching there are over 150 participants - still only display submissionParticipants
            if (filteredItemsList.length > maxItems) {
                filteredItemsList = [{id: 0, name: getLongListWarning($scope.peopleList.length), disabled: true}];
            }
        } else {
                if ($scope.peopleList.length > maxItems) {
                    filteredItemsList = [{id: 0, name: getLongListWarning($scope.peopleList.length), disabled: true}];
                } else {
                    filteredItemsList = $scope.peopleList
                }
        }

        $scope.filteredItemsList = filteredItemsList;

    };

    function getLongListWarning(listLength) {
        let message = $scope.taskReassignI18n.longListMessage;
        message = _.replace(message, '{0}', $filter('number')(listLength));
        return message;
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.reassignViewModel.selectedAssignee;
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umLanding')
    .controller('reassignModalController', ReassignModalController);
